// extracted by mini-css-extract-plugin
module.exports = {"noResultsPlaceholderContainer":"styles_noResultsPlaceholderContainer__1C0nh","gridViewContainer":"styles_gridViewContainer__gFOCr"};